<template>
  <el-dialog v-if="dialogVisible" :close-on-click-modal="false"
             :visible.sync="dialogVisible"
             width="640px"
             title="素材名称修改"
             class="global-dialog">
    <el-form label-width="90px" :model="formData" :rules="rules" ref="formRef" style="margin: 0 auto;width: 400px">
      <el-form-item label="素材名称" prop="name">
        <el-input v-model="formData.name" :maxlength="40"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button class="c-button" @click="dialogVisible = false">取 消</el-button>
      <el-button class="c-button" type="primary" @click="onSave" v-loading="loading">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
    import materialService from '../../request/service/material-service'

    export default {
        props: {
            data: Object,
            value: Boolean
        },
        data () {
            return {
                loading: false,
                formData: {name: ''},
                rules: {
                    name: [
                        {required: true, message: '名称不能为空', trigger: 'change'},
                    ],
                }
            }
        },
        computed: {
            dialogVisible: {
                get () {
                    return this.value;
                },
                set (v) {
                    this.$emit('input', v);
                }
            },
        },
        watch: {
            dialogVisible: {
                handler (v) {
                    if (v) {
                        this.init();
                    }
                },
                immediate: true
            }
        },
        methods: {
            init () {
                this.formData.name = this.data.name;
            },
            onSave () {
                this.$refs.formRef.validate((valid) => {
                    if (valid) {
                        this.save();
                    } else {
                        return false;
                    }
                });
            },
            save () {
                this.loading = true;
                let cloneData = JSON.parse(JSON.stringify(this.data));
                cloneData.name = this.formData.name;
                materialService.updateMaterial(cloneData).then(() => {
                    this.$emit('onSaveAfter', cloneData);
                    this.$message.success('更新成功');
                }).finally(() => {
                    this.loading = false;
                });
            }
        }
    }
</script>